import { render } from "./InscricoesPage.vue?vue&type=template&id=7547a5df&scoped=true"
import script from "./InscricoesPage.vue?vue&type=script&lang=js"
export * from "./InscricoesPage.vue?vue&type=script&lang=js"

import "./InscricoesPage.vue?vue&type=style&index=0&id=7547a5df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7547a5df"]])

export default __exports__